import { Types } from '../../../constants';
import { IsHelper } from '../IsHelper';
export class IsArrayHelper extends IsHelper {
    constructor() {
        super(...arguments);
        this.type = Types.Array;
    }
}

//# sourceMappingURL=IsArrayHelper.js.map
